import Constants from '@/Constants';
import { FilterOptionRequest } from '@/models/FilterOptionRequest';
import { ApplicationState } from '@/store';
import { closeModal } from '@/store/common/actions';
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

interface VisibilityOptions {
    id: FilterOptionRequest;
    icon: string;
    description: string;
    subdescription: string;
    checked: boolean;
}

interface Props {
    onSelect?: Function;
    selectedOption?: FilterOptionRequest;
}

const FilterVisibilityModal: React.FC<Props> = ({ onSelect, selectedOption }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const [visibilityOptions, setVisibilityOptions] = useState<VisibilityOptions[]>([
        {
            id: FilterOptionRequest.PRIVATE,
            icon: Constants.icons.LOCK,
            description: strings.PRIVATE,
            subdescription: strings.ONLY_ME,
            checked: selectedOption === FilterOptionRequest.PRIVATE,
        },
        {
            id: FilterOptionRequest.PUBLIC,
            icon: Constants.icons.PUBLIC,
            description: strings.PUBLIC,
            subdescription: strings.EVERYONE_IN_MY_ORGANIZATION,
            checked: selectedOption === FilterOptionRequest.PUBLIC,
        },
    ]);

    const dispatch = useDispatch();

    const selectOption = (option: FilterOptionRequest) => {
        visibilityOptions.forEach((visibilityOption: VisibilityOptions) => {
            visibilityOption.checked = visibilityOption.id === option;
        });

        setVisibilityOptions([...visibilityOptions]);

        if (onSelect) {
            onSelect(option);
        }
    };

    const dismissModalHandler = () => {
        dispatch(closeModal(Constants.modal.MORE_OPTIONS_VISIBILITY));
    };

    return (
        <div className="filter-visibility-modal">
            <Modal.Header>
                <div className="header-info">
                    <Modal.Title>
                        <span className="title">{strings.FILTER_BY_VISIBILITY}:</span>
                        <i className="material-icons-outlined align-middle" onClick={dismissModalHandler}>
                            {Constants.icons.CLOSE}
                        </i>
                    </Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="visibility-options">
                    {visibilityOptions.map((option: VisibilityOptions) => (
                        <div className="option" key={option.id}>
                            <i className="material-icons align-middle check mr-3" onClick={() => selectOption(option.id)}>
                                {option.checked ? Constants.icons.RADIO_BUTTON_CHECKED : Constants.icons.RADIO_BUTTON_UNCHECKED}
                            </i>
                            <div className="d-flex flex-column ml-1">
                                <div className="d-flex flex-row">
                                    <span className={`${option.checked ? 'description-selected' : ''}`}>{option.description}</span>
                                    <i className="material-icons align-middle visibility-icon ml-1">{option.icon}</i>
                                </div>
                                <span className={`subdescription ${option.checked ? 'subdescription-selected' : ''}`}>{option.subdescription}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
        </div>
    );
};

export default FilterVisibilityModal;
